export default {
    container: {
        position: 'relative',
        zIndex: 1,
        top: 0,
        left: '80%',
        float: 'right',
        width: '80%',
        height: '100%',
        transition: 'left 0.3s',
        WebkitTransition: 'left 0.3s'
    },
    opened: {
        left: 0
    },
    scheduleContainer: {
        position: 'relative',
        top: 0,
        width: '100%',
        height: '100%',
        background: '#fff',
        padding: 20,
        overflowY: 'auto'
    },
    toggleButton: {
        position: 'absolute',
        left: -90,
        top: 'calc(50% - 25px)',
        width: 90,
        height: 50,
        display: 'block',
        opacity: 1,
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        borderRadius: '30px 0 0 30px',
        padding: 10,
        textAlign: 'center',
        transition: 'opacity 0.2s',
        WebkitTransition: 'opacity 0.2s',
        color: '#fff'
    },
    toggleButtonHide: {
        opacity: 0
    },
    toggleButtonHidden: {
        display: 'none'
    },
    toggleButtonLabel: {
        fontSize: 12,
        position: 'absolute',
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)'
    }
};



// WEBPACK FOOTER //
// ./app/webapp/syndicated/SyndicatedScheduleModule/style.js